import {
  BaseLayout,
  Footer,
  Navigation
} from '@efast_public/fjd-component-library';
import { MandantHeader } from './header/Header';
import { Outlet } from 'react-router-dom';
import logo from '../assets/fjd_logo.svg';

export function MandantLayout() {
  return (
    <BaseLayout
      header={<MandantHeader />}
      navigation={<Navigation style={{ height: '4px' }}></Navigation>}
      mainContentWidth="nearer"
      mainContent={
        <div style={{ minHeight: 'calc(100vh - 86px - 54px - 36px)' }}>
          <Outlet />
        </div>
      }
      footer={
        <Footer
          before={<img alt="Logo Fjd" src={logo} />}
          after={
            <div>{`(${process.env.REACT_APP_BUILD_VERSION || 'local'})`}</div>
          }
        />
      }
    />
  );
}
